var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJiraLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.5C0 4.08172 3.58172 0.5 8 0.5C12.4183 0.5 16 4.08172 16 8.5C16 12.9183 12.4183 16.5 8 16.5C3.58172 16.5 0 12.9183 0 8.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8803 8.22017L8.43125 3.91711L8 3.5L4.65096 6.73918L3.11974 8.22017C2.96009 8.37477 2.96009 8.62523 3.11974 8.77983L6.17945 11.7392L8 13.5L11.349 10.2608L11.4009 10.2107L12.8803 8.77983C13.0399 8.62523 13.0399 8.37477 12.8803 8.22017ZM8 9.97835L6.47151 8.5L8 7.02165L9.52849 8.5L8 9.97835Z",
    fill: "#2684FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99991 7.02197C6.99916 6.05395 6.99429 4.48604 7.98899 3.51221L4.64404 6.7461L6.46459 8.50693L7.99991 7.02197Z",
    fill: "url(#paint0_linear_3350_262)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53259 8.49591L8 9.97822C8.48303 10.4451 8.75441 11.0785 8.75441 11.739C8.75441 12.3995 8.48303 13.033 8 13.4999L11.3531 10.2567L9.53259 8.49591Z",
    fill: "url(#paint1_linear_3350_262)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3350_262",
    x1: 7.72696,
    y1: 5.52646,
    x2: 5.17724,
    y2: 6.63972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3350_262",
    x1: 8.29205,
    y1: 11.4566,
    x2: 10.8372,
    y2: 10.3512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiraLogo);
export default __webpack_public_path__ + "static/media/Jira_logo.00cf9e5ff27f95c0ca25f9e76caad018.svg";
export { ForwardRef as ReactComponent };